
	/**
     * @description
     *  Estados posibles de un background-job.
     *
     * @see gigot-backend/Core/Persistence/Query/AsyncJobId.cs
     */

export enum JobState {

	Awaiting = "Awaiting",
	Deleted = "Deleted",
	Enqueued = "Enqueued",
	Failed = "Failed",
	Processing = "Processing",
	Scheduled = "Scheduled",
	Succeeded = "Succeeded",
	Unknown = "Unknown"
}

export const toJobStateString = function (jobState: JobState): string {
	switch (jobState) {
		case JobState.Awaiting:
			return "Esperando";
		case JobState.Deleted:
			return "Eliminado";
		case JobState.Enqueued:
			return "En cola";
		case JobState.Failed:
			return "Falló";
		case JobState.Processing:
			return "Procesando";
		case JobState.Scheduled:
			return "Programado";
		case JobState.Succeeded:
			return "Éxito";
		case JobState.Unknown:
			return "Desconocido";
		default: {
			return "[Unknown JobState]";
		}
	}
};
